import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';

import type { BasePaymentEventProps } from './basePaymentEvent.type';

export function basePaymentsEvent<CustomData extends UnknownShapeObject>({
	category,
	customData,
	name,
	schemaName,
	version,
}: BasePaymentEventProps<CustomData>): void {
	logAnalyticsEvent({
		eventPayload: getSnowplowEventPayload({
			category,
			customData,
			name,
			schemaName,
			version,
		}),
		provider: 'SNOWPLOW',
	});
}
